import { AgentNode } from "./AgentNode.tsx";
import { ConnectorNode } from "./ConnectorNode.tsx";
import { MCPServerNode } from "./MCPServerNode.tsx";
import { P0MCPNode } from "./P0MCPNode.tsx";
import { PlatformNode } from "./PlatformNode.tsx";
import { RiskNode } from "./RiskNode.tsx";
import { ToolNode } from "./ToolNode.tsx";

export {
  AgentNode,
  ConnectorNode,
  MCPServerNode,
  P0MCPNode,
  PlatformNode,
  RiskNode,
  ToolNode,
};

export const NODE_TYPES = {
  platform: PlatformNode,
  agent: AgentNode,
  p0mcp: P0MCPNode,
  mcpServer: MCPServerNode,
  connector: ConnectorNode,
  tool: ToolNode,
  risk: RiskNode,
} as const;
